import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { createContext } from "react";
import type { MorphemeHrefObject } from "@-/dev.improve.haniverse.lib.morpheme.href.entities";

export interface MorphemeMnemonicsMeaningViewContextValue {
  morphemeHrefObject: MorphemeHrefObject;
  openCompoundsSheet: () => void;
  /** Opens the sheet of characters whose mnemonics use this grapheme as a component. */
  openMnemonicUsagesSheet: () => void;
}

export const MorphemeMnemonicsMeaningViewContext = createContext(
  defaultError<MorphemeMnemonicsMeaningViewContextValue>("MorphemeMnemonicsMeaningViewContext"),
);
